import * as React from 'react';

import { ActionButtons } from '../../../../components/ActionButtons';
import { useMessageContext } from '../../../../utils/messageContext';
import { TActionButtonV2 } from '../../../../types/actionButtonV2';
import { TActionButtonV3 } from '../../../../types/actionButtonV3';
import { shouldShowDailyrentButtons } from '../../../../utils/dailyrent/shouldShowDailyrentButtons';
import { ActionButtonContainer } from '../../../ActionButtonContainer';

export const ActionButtonsContainer: React.FC = () => {
  const { message, messageId } = useMessageContext();
  const { actionButtons, actionButtonsV3 } = message;

  const buttons = React.useMemo(() => {
    if (actionButtonsV3?.length) {
      return actionButtonsV3.map((actionButton: TActionButtonV3, index: number) => (
        <ActionButtonContainer
          key={index}
          actionButton={actionButton}
          messageId={messageId}
          communicationId={message.communicationId}
          index={index}
          isOutcoming={message.isOutcoming}
        />
      ));
    }

    if (actionButtons?.length) {
      return actionButtons.map((actionButton: TActionButtonV2, index: number) => (
        <ActionButtonContainer
          key={index}
          actionButton={actionButton}
          messageId={messageId}
          communicationId={message.communicationId}
          index={index}
          isOutcoming={message.isOutcoming}
        />
      ));
    }

    return null;
  }, [actionButtons, actionButtonsV3, message, messageId]);

  if (!buttons) {
    return null;
  }

  return <ActionButtons buttons={buttons} showDailyRentButtons={shouldShowDailyrentButtons(actionButtons)} />;
};
